import { useState } from 'react';
import { LoaiVatTu } from '@/types/schemas/loai-vat-tu.type';
import { DialogV2 } from '@/components/custom/erp';

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  selectedObj: LoaiVatTu | null;
  deleteLoaiVatTu: (uuid: string) => Promise<void>;
  clearSelection: () => void;
}

const DeleteDialog = ({ open, onClose, selectedObj, deleteLoaiVatTu, clearSelection }: DeleteDialogProps) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    if (!selectedObj) return;

    setIsDeleting(true);
    setError(null);

    try {
      await deleteLoaiVatTu(selectedObj.uuid);
      onClose();
      clearSelection();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Có lỗi xảy ra khi xóa');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <DialogV2 open={open} onClose={onClose} title='Xác nhận xóa' maxWidth='sm'>
      <div className='p-4'>
        <p className='mb-4'>
          Bạn có chắc chắn muốn xóa loại vật tư <strong>{selectedObj?.ten_lvt}</strong>?
        </p>

        {error && <div className='mb-4 rounded bg-red-100 p-2 text-red-700'>{error}</div>}

        <div className='flex justify-end space-x-2'>
          <button
            onClick={onClose}
            className='rounded border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50'
            disabled={isDeleting}
          >
            Hủy
          </button>
          <button
            onClick={handleDelete}
            className='rounded bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700'
            disabled={isDeleting}
          >
            {isDeleting ? 'Đang xóa...' : 'Xóa'}
          </button>
        </div>
      </div>
    </DialogV2>
  );
};

export default DeleteDialog;
